"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeCaretAtEnd = void 0;
function placeCaretAtEnd(element) {
    const range = document.createRange();
    range.selectNodeContents(element);
    range.collapse(false);
    const selection = window.getSelection();
    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
    selection === null || selection === void 0 ? void 0 : selection.addRange(range);
}
exports.placeCaretAtEnd = placeCaretAtEnd;
